import React from 'react';

class DisplayEmail extends React.Component {
  render() {
    return (
      <> <a href={`mailto:{this.props.email}`}> {this.props.email} </a><br></br> </>
    );
  }
}
export default DisplayEmail;